import {IBotConfig} from "@game/coregame/interfaces/IBotConfig";

const extendConfig = (
    overrides?: Partial<IBotConfig>,
    baseConfig: IBotConfig = {
        waitTimeBetweenDecisions: 1,
        traceDuration: 6,
        stepDuration: 0.5,
        forcesBalanceFactor: 1,
        buildingsBalanceFactor: 1,
        spawnBalanceFactor: 1,
        fightersInSegment: 10,
        isConsiderGroupToGroupIntersection: false,
        commandInDecisionOrder: [0, 0],
        maxBuildingsMove: 3,
        targetReachedTimeBoost: 0,
        alivePlayerBuildingsLimit: -1,
        isForbiddenUpgrade: false
    }
) => ({...baseConfig, ...overrides} as IBotConfig);

export const BotPreset0Vegetable: IBotConfig = extendConfig({
    name: "0Vegetable",
    waitTimeBetweenDecisions: 10,
    traceDuration: 10,
    stepDuration: 0.5,
    forcesBalanceFactor: 0.2,
    buildingsBalanceFactor: 1,
    spawnBalanceFactor: 0,
    fightersInSegment: 10,
    maxBuildingsMove: 3,
    targetReachedTimeBoost: 2,
    alivePlayerBuildingsLimit: 2
});
export const BotPreset1Easy: IBotConfig = extendConfig({
    name: "1Easy",
    waitTimeBetweenDecisions: 12,
    traceDuration: 15,
    stepDuration: 0.5,
    forcesBalanceFactor: 0.1,
    buildingsBalanceFactor: 1,
    spawnBalanceFactor: 0,
    fightersInSegment: 10,
    maxBuildingsMove: 2,
    targetReachedTimeBoost: 2,
    alivePlayerBuildingsLimit: -1
});
export const BotPreset2Medium: IBotConfig = extendConfig({
    name: "2Medium",
    waitTimeBetweenDecisions: 7,
    traceDuration: 10,
    stepDuration: 0.5,
    forcesBalanceFactor: 1,
    buildingsBalanceFactor: 2,
    spawnBalanceFactor: 0,
    fightersInSegment: 10,
    maxBuildingsMove: 3,
    targetReachedTimeBoost: 2,
    alivePlayerBuildingsLimit: -1
});
export const BotPreset3UpperMedium: IBotConfig = extendConfig({
    name: "3UpperMedium",
    waitTimeBetweenDecisions: 5,
    traceDuration: 10,
    stepDuration: 0.25,
    forcesBalanceFactor: 1,
    buildingsBalanceFactor: 2,
    spawnBalanceFactor: 1,
    fightersInSegment: 10,
    maxBuildingsMove: 3,
    targetReachedTimeBoost: 1,
    alivePlayerBuildingsLimit: -1
});
export const BotPreset4Hard: IBotConfig = extendConfig({
    name: "4Hard",
    waitTimeBetweenDecisions: 5,
    traceDuration: 20,
    stepDuration: 0.2,
    forcesBalanceFactor: 0,
    buildingsBalanceFactor: 1,
    spawnBalanceFactor: 0,
    fightersInSegment: 10,
    maxBuildingsMove: 4,
    targetReachedTimeBoost: 1,
    alivePlayerBuildingsLimit: -1
});
export const BotPreset5Final: IBotConfig = extendConfig({
    name: "5Final",
    waitTimeBetweenDecisions: 4,
    traceDuration: 20,
    stepDuration: 0.1,
    forcesBalanceFactor: 1,
    buildingsBalanceFactor: 1,
    spawnBalanceFactor: 1,
    fightersInSegment: 10,
    maxBuildingsMove: 3,
    targetReachedTimeBoost: 0,
    alivePlayerBuildingsLimit: -1
});
export const BotPreset6FinalAgressive: IBotConfig = extendConfig({
    name: "6FinalAgressive",
    waitTimeBetweenDecisions: 4,
    traceDuration: 30,
    stepDuration: 0.1,
    forcesBalanceFactor: 1,
    buildingsBalanceFactor: 0
});
